/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// wrapRootElement ok from Plugin ;)

// import React from "react";
// export const wrapRootElement = ({ element }) => {
//   return <div>GOOD JOB. {element}</div>;
// };
import { initUser } from "./src/services/auth";

// On app start, try init logged in user
export const onClientEntry = async () => {
  console.log("Init user Session...");
  await initUser();
};
